import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_fryzjer-artysta/artifacts/1zs7ekyu_logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/5">
      {/* Main footer */}
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO} alt="Fryzjer Artysta" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-anton text-2xl text-white leading-none">FRYZJER</div>
                <div className="font-anton text-xs tracking-[0.4em] leading-none" style={{ color: "#A855F7" }}>ARTYSTA</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Milena Bachara - kolorystka z pasją. Tworzy włosy jak dzieła sztuki. Umów wizytę lub weź udział w szkoleniu.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="https://www.instagram.com/fryzjer_artysta/" target="_blank" rel="noopener noreferrer"
                data-testid="footer-instagram" className="text-white/40 hover:text-white transition-colors p-2 border border-white/10 hover:border-violet-600/50">
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-outfit text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Nawigacja</h4>
            <ul className="space-y-3">
              {[
                { to: "/o-mnie", label: "O Mnie" },
                { to: "/uslugi", label: "Usługi" },
                { to: "/galeria", label: "Galeria" },
                { to: "/szkolenia", label: "Szkolenia" },
                { to: "/kontakt", label: "Kontakt" },
                { to: "/rezerwacja", label: "Rezerwacja" },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/50 hover:text-white text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={14} className="text-violet-500 mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">+48 798 943 906</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={14} className="text-violet-500 mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">fryzjerartystamilena@gmail.com</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-violet-500 mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">Tarnów, ul. Reymonta 25<br />33-100 Małopolska</span>
              </li>
              <li className="flex items-start gap-3">
                <Instagram size={14} className="text-violet-500 mt-0.5 flex-shrink-0" />
                <a href="https://www.instagram.com/fryzjer_artysta/" target="_blank" rel="noopener noreferrer"
                  className="text-white/60 hover:text-white text-sm transition-colors">@fryzjer_artysta</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-white/25 text-xs">© 2026 Fryzjer Artysta - Milena Bachara. Wszelkie prawa zastrzeżone.</p>
          <div className="text-white/15 text-xs hidden md:block">
            NIP: 8733280376 · REGON: 389339228 · ul. Reymonta 25, 33-100 Tarnów
          </div>
          <div className="flex flex-wrap gap-4 items-center">
            <Link to="/regulamin" className="text-white/30 hover:text-white/70 text-xs transition-colors">Regulamin</Link>
            <span className="text-white/10 text-xs">|</span>
            <Link to="/polityka-prywatnosci" className="text-white/30 hover:text-white/70 text-xs transition-colors">Polityka Prywatności</Link>
            <span className="text-white/10 text-xs">|</span>
            <Link to="/polityka-zwrotow" className="text-white/30 hover:text-white/70 text-xs transition-colors">Polityka Zwrotów</Link>
            <span className="text-white/10 text-xs">|</span>
            <Link to="/admin/login" className="text-white/15 hover:text-white/40 text-xs transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
